import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden" aria-label="首页主视觉">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20abstract%20comic%20book%20themed%20background%20with%20dynamic%20motion%20lines%2C%20ink%20splashes%20in%20warm%20crimson%20and%20golden%20tones%2C%20floating%20comic%20panel%20frames%2C%20japanese%20manga%20style%20speed%20lines%2C%20dramatic%20energy%20bursts%2C%20dark%20rich%20atmosphere%20with%20vibrant%20warm%20accents%2C%20no%20text%20or%20characters%2C%20pure%20abstract%20composition&width=1800&height=900&seq=hero-bg-comic-01&orientation=landscape"
          alt="jm漫画 - 正版在线漫画平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/30 backdrop-blur-sm mb-6">
            <i className="ri-verified-badge-line text-accent-400 text-sm"></i>
            <span className="text-xs text-accent-300 font-medium">正版授权 · 海量漫画 · 每日更新</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
            探索无限漫画世界
            <br />
            <span className="text-accent-400">精彩故事从这里开始</span>
          </h1>

          <p className="text-sm md:text-base text-foreground-100/80 max-w-xl mx-auto mb-8 leading-relaxed">
            jm漫画是深受用户喜爱的在线漫画阅读平台。海量正版漫画资源，涵盖热血、恋爱、悬疑、奇幻等多种类型，手机、平板、电脑多端畅读，每日更新最新章节。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/rexue"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-open-line"></i>
              立即阅读
            </Link>
            <a
              href="#download"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full border border-background-50/30 text-background-50 font-semibold text-sm hover:bg-background-50/10 backdrop-blur-sm transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line"></i>
              下载APP
            </a>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">10,000+</p>
              <p className="text-xs text-foreground-100/60 mt-1">正版漫画</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-accent-400">5000万+</p>
              <p className="text-xs text-foreground-100/60 mt-1">活跃用户</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">每日更新</p>
              <p className="text-xs text-foreground-100/60 mt-1">永不断更</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}